import { OpinionPoll } from '@/modules/opinions';
import { RootStore } from '@/store';
import { action, makeAutoObservable } from 'mobx';

export class ProfileStore {
  readonly rootStore: RootStore;

  public opinions: OpinionPoll[] = [];

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }

  public setOpinions = action((opinions: OpinionPoll[]) => {
    this.opinions = opinions;
  });
}
